





















import { Component, Inject, Watch, Mixins } from 'vue-property-decorator';
import { AxiosInstance as ApiInstance } from 'axios';
import { remoteEduService } from '@/services';
import { eduData } from '@/pages/profile/utils';
import WebinarsModule from '../../webinars';
import { LoaderMixin } from '@/pages/profile/mixins';
import { IWebinars } from './types';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';

@Component({
  components: {
    AppButtonNew,
    WebinarsModule,
  },
  metaInfo: () => ({
    title: 'Вебинары',
  }),
  created() {
    this.setStatus('LOADING');
  },
  computed: {
    isReadyForExecute() {
      return (
        this.$store.state.user.profile && this.$store.state.user.profile.id
      );
    },
  },
  watch: {
    isReadyForExecute(value) {
      if (value) {
        this.getData();
      }
    },
  },

  mounted() {
    if (!this.isReadyForExecute) return;
    this.getData();
  },
})
export default class Webinars extends Mixins(LoaderMixin) implements IWebinars {
  @Inject() $api: ApiInstance;

  webinars: Array<any> = [];
  vkAuth: Boolean | null = null;
  vkAuthing: Boolean = false;
  errorText: String = '';
  paginatorData: Object = { filtered: 1, limit: 1, page: 1 };

  get id(): string {
    return this.$store.state.user.profile
      ? this.$store.state.user.profile.id
      : null;
  }

  @Watch('$route.query.payload', { immediate: true })
  async setReviewResult(newVal: any) {
    if (newVal) {
      this.vkAuthing = true;
      try {
        await this.$api.get('sferum/get/user', {
          params: {
            payload: newVal,
          },
        });
        await this.getData();
        this.$router.push({
          query: {
            payload: '',
          },
        });
      } catch (e) {
        this.vkAuthing = false;
      } finally {
        this.vkAuthing = false;
      }
    }
  }
  @Watch('$route.query.page', { immediate: true })
  async updatePage() {
    await this.getData();
  }

  get showSferumBlock() {
    return this.$store.getters.hasSferumModule;
  }
  // @Watch('id', { immediate: true })
  // onChangeChild(id: string): void {
  //   if (!id) return;
  //   this.getData();
  // }

  async getData() {
    const page = this.$route.query?.page || 1;
    const { $api, id } = this;
    if (!id) return;
    this.setStatus('loading');
    if (this.$store.getters.hasSferumModule) {
      try {
        const { data: webinars } = await remoteEduService(
          $api
        ).getSferumWebinars(id, page);
        this.paginatorData = {
          filtered: Number(webinars.filtered),
          limit: Number(webinars.limit),
          page: Number(webinars.page),
        };
        const data = webinars.data.reduce((acc: any, value: any) => {
          const current = acc.find(
            (currArrValue: any) => currArrValue.group_id === value.group_id
          );
          if (current) {
            current.children.push(value);
          } else {
            acc.push({
              group_id: value.group_id,
              group_name: value.chat_title,
              chat_link: value.chat_link,
              children: [value],
            });
          }
          return acc;
        }, []);
        this.vkAuth = true;
        // console.log(data);
        this.webinars = data;
        this.setStatus('success');
      } catch (err) {
        this.vkAuth = false;
        this.errorText = err.response.data.message;
        this.webinars = [];
        this.setStatus('error');
      }
    } else {
      try {
        const { data } = await remoteEduService($api).getRemoteEduRooms(id);
        this.webinars = eduData(data);
        this.setStatus('success');
      } catch (err) {
        this.webinars = [];
        this.setStatus('error');
      }
    }
  }
  async goToVk() {
    try {
      const data = await this.$api.get('sferum/auth');
      window.location.assign(data.data.data.redirect_url);
    } catch (e) {
      // console.log(e.headers);
    }
  }
  async disconnect() {
    try {
      await this.$api.get('sferum/unset/user');
      await this.getData();
    } catch (e) {
      // console.log(e.headers);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/views/webinars/Webinars.vue